<template>
  <div>
    <div class="row">
      <div class="col-12 ">
        <editor
          ref="tinymce"
          v-model="frmData.content"
          :init="tinyOptions"
        />
      </div>
    </div>

    <b-modal
      id="modal-file-manager"
      ref="modalFileManager"
      v-model="showFileManagerModal"
      :title="fileManagerTitle"
      size="xl"
      :ok-only="true"
      ok-title="Đóng"
      hide-footer
      scrollable
    >
      <file-manager />
    </b-modal>
  </div>
</template>

<script>

import {
  BModal,
} from 'bootstrap-vue'
import {
  ref, computed, reactive, toRefs,
} from '@vue/composition-api'
import { getToken } from '@/auth/utils'
import useJwt from '@/auth/jwt/useJwt';
import { defaultOptions, apiUpload, apiDownload } from '@/libs/initTinymce';
import store from '@/store'
import Editor from '@tinymce/tinymce-vue'
import FileManager from '../files/FileManager.vue';

export default {
  components: {
    BModal,
    Editor,
    FileManager,
  },
  data() {
    return {
      all_cats: [],
      data_cats: [],
      api_upload: `${process.env.VUE_APP_NEWS_API_URL}manager/upload`,
      // showFileManagerModal: false,
    }
  },
  computed: {
    fileManagerTitle() {
      return this.$store.state.files.file_manager.title;
    },
    showFileManagerModal: {
      get() {
        // console.log('show_file_manager', this.$store.state.files.show_file_manager);
        return this.$store.state.files.show_file_manager;
      },
      set(val) {
        this.$store.dispatch('files/setState', { show_file_manager: val });
      },
    },
  },
  setup() {
    const dataUser = useJwt.getUserLocal();

    // const logoMask = ref('https://vovat.mediatech.vn:3011/upload/setting/843bc173898300d47abec8a5b14d677d.22042023.png');
    // defaultOptions.images_mask_logo = logoMask.value;
    // defaultOptions.toolbar += ' image_manager video_manager';

    const state = reactive({
      tinyOptions: null,
      api_upload: apiUpload,
      api_download: apiDownload,
    })
    state.tinyOptions = computed(() => {
      if (store.state.app.settings) {
        if (store.state.app.settings.news !== undefined && store.state.app.settings.news.editor_toolbar !== undefined) {
          const icons = store.state.app.settings.news.editor_toolbar.map(({ icon }) => icon);
          defaultOptions.toolbar = icons.join(' ');
        }
        if (store.state.app.settings.app !== undefined && store.state.app.settings.app.logo_mask !== undefined) {
          defaultOptions.images_mask_logo = 'https://auth.tintucvov.vn/upload/setting/e97f6caa278662da90be88a4e6299d5c.31052023.png';// store.state.app.settings.app.logo_mask;
        }
      }
      console.log('defaultOptions', defaultOptions);
      return defaultOptions
    });
    // const tinyOptions = ref(defaultOptions);
    const defaultItemData = {
      content: `<p>sdsdsds</p>
      <p><img src="https://media.tintucvov.vn/upload/bg_weather_20230616071253.jpg"></p>
      <p>&nbsp;</p>
    <p class="text-align-right" style="text-align: right;"><strong><em>Super Admin2--Cộng t&aacute;c vi&ecirc;n--CTV Đ&agrave;i TNVN</em></strong></p>`,
    }
    const frmData = ref(JSON.parse(JSON.stringify(defaultItemData)))
    const resetItemData = () => {
      frmData.value = JSON.parse(JSON.stringify(defaultItemData))
    }

    const accessToken = getToken();
    const custom_header = ref({
      Authorization: `Bearer ${accessToken}`,
    });

    return {
      ...toRefs(state),
      frmData,
      custom_header,
      resetItemData,
    }
  },
  mounted() {

  },
  methods: {

  },

}
</script>

<style lang="scss" >
img {
  // max-height: 100%;
}

.canvas-container {
  max-width: 100%;
  max-height: 100%;
}
</style>
